/* eslint-disable import/first */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Type } from '@spotify-internal/encore-creator-web';
import {
  LOADING,
  ERROR,
  selectEpisodeStartsStreams,
  selectEpisodeStartsStreamsStatus,
  selectDateRange,
} from '../../../store/selectors';
import { loadEpisodeStartsStreams } from '../../../store/episodeStartsStreams';
import { StartsStreams } from '../../../components/Shared/Charts/StartsStreamsChart';
import { LoadingIndicator } from '../../../components/Shared/LoadingIndicator';
import { DateRangeWithLabel, DetailedStream, ReduxState } from '../../../types';
import { FormattedMessage } from 'react-intl';

type Props = {
  episodeId: string;
  status?: 'LOADING' | 'ERROR';
  episodeStartsStreams?: DetailedStream[];
  dateRange?: DateRangeWithLabel;
  loadEpisodeStartsStreams: typeof loadEpisodeStartsStreams;
};

export class EpisodeStartsStreamsContainer extends PureComponent<Props> {
  componentDidMount() {
    this.props.loadEpisodeStartsStreams(this.props.episodeId);
  }

  /* istanbul ignore next */
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!this.props.dateRange || !nextProps.dateRange) return;

    if (
      nextProps.dateRange.startDate !== this.props.dateRange.startDate ||
      nextProps.dateRange.endDate !== this.props.dateRange.endDate
    ) {
      this.props.loadEpisodeStartsStreams(this.props.episodeId);
    }
  }

  render() {
    if (this.props.status === ERROR) {
      return <span data-qa="episode-starts-streams-error" />;
    }

    if (!this.props.episodeStartsStreams && this.props.status !== LOADING) {
      return null;
    }

    return (
      <div data-qa="episode-starts-streams-chart">
        <Type as="h1" variant={Type.heading3}>
          <FormattedMessage id="episode.starts-streams.title" defaultMessage="Starts & Streams" />
        </Type>
        {this.props.status === LOADING ? (
          <div style={{ width: '100%', height: '350px' }}>
            <LoadingIndicator />
          </div>
        ) : (
          <StartsStreams startsStreams={this.props.episodeStartsStreams!} />
        )}
      </div>
    );
  }
}

function mapStateToProps(state: ReduxState) {
  return {
    episodeStartsStreams: selectEpisodeStartsStreams(state),
    status: selectEpisodeStartsStreamsStatus(state),
    dateRange: selectDateRange(state),
  };
}

const actions = { loadEpisodeStartsStreams };

export const ConnectedEpisodeStartsStreamsContainer = connect(
  mapStateToProps,
  actions,
)(EpisodeStartsStreamsContainer);
